<div id="cremation" class="column module-top-gap">
    <div class="column">
        <h1 class="redesign">Tipps & Tricks</h1>
        <h3 class="redesign subtext">Urnen ins Ausland</h3>
    </div>

    <div class="tips-container">
        <div class="search-section">
            <div class="search-container">
                <input type="text" 
                       placeholder="Land suchen..." 
                       (input)="onSearch($event)"
                       class="search-input">
            </div>
            
            <div class="category-filter">
                <select (change)="onCategoryChange($any($event.target).value)" class="category-select">
                    <option *ngFor="let category of categories" [value]="category.id">
                        {{category.name}}
                    </option>
                </select>
            </div>
        </div>

        <div class="alphabet-filter">
            <button 
                *ngFor="let letter of alphabet" 
                class="letter-button"
                [class.active]="selectedLetter === letter"
                [class.disabled]="!hasCountriesForLetter(letter)"
                (click)="onLetterSelect(letter)"
            >
                {{letter}}
            </button>
        </div>

        <div class="countries-grid">
            <div *ngFor="let country of filteredCountries" class="country-card">
                <h3>{{country.name}}</h3>
                <div class="document-links">
                    <a *ngIf="country.shippingPdf" 
                       class="action prefixed"
                       [href]="'assets/download/' + country.shippingPdf"
                       target="_blank">
                        Versand
                    </a>
                    <a *ngIf="country.transferPdf" 
                       class="action prefixed"
                       [href]="'assets/download/' + country.transferPdf"
                       target="_blank">
                        Überführung
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>